import { RecoveringState } from "../pages";
import { EventEmitter } from 'events';
import { RecoveringActionTypes } from "../actions/RecoveringActions";
import { ChangeEvent, TranscriptionEvent } from "./utils";
import Dispatcher from '../dispatcher';

const defaultState: RecoveringState = {
    recoveredTranscriptionFile: null,
    showAuthPopup: false
};
  
class RecoveringStore extends EventEmitter {
    private state: RecoveringState;

    constructor() {
        super();

        this.state = this.getInitialState();
    }

    private getInitialState = (): RecoveringState => {
        // Make sure we are not passing a reference to the object
        return Object.assign({}, defaultState);
    }

    public getState = (): RecoveringState => {
        // Make sure we are not passing a reference to the object
        return Object.assign({}, this.state);
    }

    public handleActions = (action: Event): void => {
        switch(action.type) {
            case RecoveringActionTypes.SetRecoveredTranscriptionFile:
                this.state.recoveredTranscriptionFile =  (<TranscriptionEvent> action).payload;
                this.emit(ChangeEvent.Change);
                break;
            case RecoveringActionTypes.SetShowAuthPopupAction:
                this.state.showAuthPopup = (<TranscriptionEvent> action).payload;
                this.emit(ChangeEvent.Change);
                break;
            }
    }
}

const recoveringStore = new RecoveringStore;
Dispatcher.register(recoveringStore.handleActions);
export default recoveringStore;
